import { defaultVariantIcon, cardWithWrappersVariantIcon } from './icons';
import { DEFAULT_CSS_CLASS } from '@constants';
const defaultImageUrl = 'https://placehold.co/600x400';
const defaultBlockCssClass = DEFAULT_CSS_CLASS.CARD;
const buttonBlockCssClass = DEFAULT_CSS_CLASS.BUTTON;
const variations = [
  {
    name: 'default-card',
    title: 'Default Card',
    icon: defaultVariantIcon,
    attributes: {
      blockClassNames: [
        {
          value: `${defaultBlockCssClass}--dlt`,
          label: 'Dlt',
        },
      ],
    },
    innerBlocks: [
      [
        'core/image',
        {
          url: defaultImageUrl,
          useExtendedAttributes: true,
        },
      ],
      ['core/heading', { level: 2, placeholder: 'Title' }],
      ['core/heading', { level: 3, placeholder: 'Sub title' }],
      ['core/paragraph', { placeholder: 'description' }],
      [
        'b3rg/button',
        {
          blockClassNames: [
            {
              value: `${buttonBlockCssClass}--primary`,
              label: 'Primary',
            },
          ],
        },
        [
          [
            'core/paragraph',
            {
              className: 'title',
              content: 'Button Text',
              placeholder: 'Add Button Title',
            },
          ],
        ],
      ],
    ],
    scope: ['block'],
  },
  {
    name: 'card-with-link-wrapper',
    title: 'Card with wrapper link',
    icon: defaultVariantIcon,
    innerBlocks: [
      [
        'core/image',
        {
          url: defaultImageUrl,
          useExtendedAttributes: true,
        },
      ],
      ['core/heading', { level: 2, placeholder: 'Title' }],
      ['core/heading', { level: 3, placeholder: 'Sub title' }],
      ['core/paragraph', { placeholder: 'description' }],
      [
        'b3rg/button',
        {
          blockClassNames: [
            {
              value: `${buttonBlockCssClass}--primary`,
              label: 'Primary',
            },
          ],
        },
        [
          [
            'core/paragraph',
            {
              className: 'title',
              content: 'Button Text',
              placeholder: 'Add Button Title',
            },
          ],
        ],
      ],
    ],
    scope: ['block'],
    attributes: {
      enableLink: true,
      blockClassNames: [
        {
          value: `${defaultBlockCssClass}--dlt`,
          label: 'Dlt',
        },
      ],
    },
  },
  {
    name: 'card-wrappers',
    title: 'Card with wrappers',
    icon: cardWithWrappersVariantIcon,
    attributes: {
      blockClassNames: [
        {
          value: `${defaultBlockCssClass}--dlt`,
          label: 'Dlt',
        },
        {
          value: `${defaultBlockCssClass}--side-by-side`,
          label: 'Side By Side',
        },
      ],
    },
    innerBlocks: [
      [
        'b3rg/div',
        {},
        [
          [
            'core/image',
            {
              url: defaultImageUrl,
              useExtendedAttributes: true,
            },
          ],
        ],
      ],
      [
        'b3rg/div',
        {},
        [
          ['core/heading', { level: 2, placeholder: 'Title' }],
          ['core/heading', { level: 3, placeholder: 'Sub title' }],
          ['core/paragraph', { placeholder: 'description' }],
          [
            'b3rg/button',
            {
              blockClassNames: [
                {
                  value: `${buttonBlockCssClass}--primary`,
                  label: 'Primary',
                },
              ],
            },
            [
              [
                'core/paragraph',
                {
                  className: 'title',
                  content: 'Button Text',
                  placeholder: 'Add Button Title',
                },
              ],
            ],
          ],
        ],
      ],
    ],
    scope: ['block'],
  },
];

export default variations;
